import "antd/dist/antd.css";
import "../../App.scss";

/* eslint-disable no-shadow */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";

import { DatePicker, message, Table } from "antd";
import moment from "moment";
import qs from "qs";
import { useHistory } from "react-router-dom";

import dog from "../../Images/sleeping-dog-with-cloud.png";
import { getEarningByMonthAndMango } from "../api/index";

const UserDetails = ({ match }) => {
  const [userDetails, setUserDetails] = useState([]);
  const [date, setDate] = useState(moment(new Date()).format("MM-YYYY"));
  const history = useHistory();

  const dogImage = <img src={dog} alt="No Data" />;

  useEffect(async () => {
    try {
      const { userId } = qs.parse(history.location.search.slice(1));
      if (userId) {
        const earningDetails = await getEarningByMonthAndMango(userId, date);
        if (earningDetails.code === 0) {
          setUserDetails(earningDetails?.result);
        } else if (
          earningDetails.code === 401 ||
          earningDetails.status === 401
        ) {
          localStorage.clear();
          history.push("/");
          earningDetails?.message
            ? message.error(earningDetails?.message)
            : message.error("Something went wrong");
        } else {
          earningDetails?.message
            ? message.error(earningDetails?.message)
            : message.error("Something went wrong");
        }
      }
    } catch (error) {
      console.log(error);
      alert(error.message);
    }
    return () => {
      setUserDetails([]);
    };
  }, [date]);

  const onChange = (date, dateString) => {
    if (date) {
      console.log(date.format("MM-YYYY"));
      setDate(date.format("MM-YYYY"));
    } else {
      setDate(moment(new Date()).format("MM-YYYY"));
    }
  };

  const displayUserDetails = () => {
    const tableData = userDetails.reduce((acc, eachDetails) => {
      return [
        ...acc,
        {
          key: eachDetails?._id?.mango,
          mangoName: eachDetails?._id?.mangoName,
          noOfSubscribers: eachDetails?.noOfSubscribers,
          earned: eachDetails?.earned,
          transferred: eachDetails?.transferred,
          createdAt: moment(eachDetails?.createdAt).format(
            "MMMM Do YYYY, h:mm:ss a"
          ),
        },
      ];
    }, []);

    const columnData = [
      {
        title: "Mango Name",
        dataIndex: "mangoName",
        key: "mangoName",
      },
      {
        title: "No of Subscribers",
        dataIndex: "noOfSubscribers",
        key: "noOfSubscribers",
      },
      {
        title: "Earned",
        dataIndex: "earned",
        key: "earned",
      },
      {
        title: "Transferred",
        dataIndex: "transferred",
        key: "transferred",
      },
      {
        title: "Created On",
        dataIndex: "createdAt",
        key: "createdAt",
      },
    ];
    return (
      <>
        {
          userDetails.length > 0 ? (
            <Table columns={columnData} dataSource={tableData} />
          ) : (
            <p>No Data Found </p>
          )
          // <Result icon={dogImage} title="No data found" />
        }
      </>
    );
  };

  return (
    <>
      <DatePicker onChange={onChange} picker="month" />
      {userDetails?.length > 0 ? displayUserDetails() : null}
    </>
  );
};

export default UserDetails;
